export default {
  methods: {
    getScoreClass(score) {
      if (score < 3) {
        return 'poor';
      }
      if (score < 6) {
        return 'moderate';
      } else {
        return 'strong';
      }
    },
  },
};
